module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Regular_V1000.e82bac96.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/dacia-spirit/DaciaSpirit-Regular_V1000.woff
// module id = 767
// module chunks = 6